import { render, staticRenderFns } from "./USRegionsPercentile.vue?vue&type=template&id=369cc0f0&"
import script from "./USRegionsPercentile.vue?vue&type=script&lang=js&"
export * from "./USRegionsPercentile.vue?vue&type=script&lang=js&"
import style0 from "./USRegionsPercentile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports